import { makeStyles, Theme } from '@material-ui/core/styles';

export const baseStyles = makeStyles((theme: Theme) => ({
  html: {
    scrollBehavior: 'smooth'
  },
  main: {
    margin: '0 auto',
    /*padding: '10px',*/
    display: 'flex',
    flex: 1,
    flexDirection: 'column'
  },
  h1: {
    fontSize: theme.typography.pxToRem(38),
    marginBottom: '1.25rem',
    marginTop: 50,
    fontWeight: 300,
    color: theme.palette.primary.light,
    lineHeight: '40px'
  },
  spacingNone: {
    marginBottom: 0
  },
  spacingNormal: {
    marginBottom: '20px'
  },
  spacingMedium: {
    marginBottom: '25px'
  },
  spacingLarge: {
    marginBottom: '30px'
  },
  spacingLargeTop: {
    marginTop: '30px'
  },
  spacingExtraLarge: {
    marginBottom: '50px'
  },
  spacingBottom45: {
    marginBottom: '45px'
  },
  htmlWrapper: {
    '& p': {
      fontSize: theme.typography.pxToRem(20),
      fontWeight: 300,
      lineHeight: '1.5rem'
    },
    '& p:nth-child(1), p:nth-child(2), p:nth-child(3)': {
      marginTop: 0,
      marginBottom: '30px'
    },
    '& p:last-child': {
      marginBottom: '20px'
    },
    '& h4:last-child': {
      marginBottom: '12px'
    }
  },
  flosIcon: {}
}));
